import "./InputField.scss"

interface InputFieldProps {
  id: string
  name?: string
  onChange: (value: string) => void
  value: string
  labelText?: string
  type?: string
  required?: boolean
  pattern?: string
  title?: string
}

export const InputField: React.FC<InputFieldProps> = ({
  id,
  name,
  onChange,
  value,
  labelText,
  type = "text",
  required,
  pattern,
  title,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value)
  }

  return (
    <div className="input-field-container">
      {labelText && (
        <label htmlFor={id} className="label">
          {labelText}
        </label>
      )}
      <input
        id={id}
        name={name}
        type={type}
        className="input-field"
        onChange={handleChange}
        value={value}
        required={required}
        pattern={pattern}
        title={title}
      />
    </div>
  )
}
